export const TEXT_EDITOR_TAG_NAME = "text-editor" as const;

export const TEXT_EDITOR_VARIANTS = ["default", "filled"] as const;

export const TEXT_EDITOR_TOOLBAR_VARIANTS = ["default", "ghost"] as const;

export const TEXT_EDITOR_TOOLBAR_PLACEMENTS = ["inline", "floating"] as const;

export const TEXT_EDITOR_TOOLS = [
  "bold",
  "italic",
  "underline",
  "strike",
  "bulletList",
  "orderedList",
  "link",
  "undo",
  "redo",
] as const;

export const TEXT_EDITOR_TOOL_GROUPS = {
  bold: "marks",
  italic: "marks",
  underline: "marks",
  strike: "marks",
  bulletList: "lists",
  orderedList: "lists",
  link: "link",
  undo: "history",
  redo: "history",
} as const;

export const DEFAULT_TEXT_EDITOR_ROWS = 4;
